import React, { useCallback } from "react";
import { Pagination } from "@material-ui/lab";
import { Box, BoxProps } from "@material-ui/core";

export type CustomPaginationProps = BoxProps & {
  page: number;
  pageSize: number;
  count: number;
  setPage: (page: number) => void;
};

export const CustomPagination: React.FC<CustomPaginationProps> = ({
  page,
  pageSize,
  count,
  setPage,
  ...props
}) => {
  const handleChange = useCallback(
    (event: any, page: number) => setPage(page),
    [setPage],
  );

  return count > pageSize ? (
    <Box {...props}>
      <Pagination
        data-testid="CustomPagination"
        count={Math.ceil(count / pageSize)}
        variant="outlined"
        size="large"
        color="primary"
        page={page}
        onChange={handleChange}
      />
    </Box>
  ) : null;
};
